<!--Main Map-->
<div>
	<caass-bus-main-map> </caass-bus-main-map>
</div>

<!--Table of Alerts Sent by School-->
<div class="AccordianDiv">
	<p-accordion>
		<p-accordionTab
			header="Alerts Sent by School to Buses {{ SchoolAlertsExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}"
			[(selected)]="SchoolAlertsExpand"
		>
			<div>
				<caass-school-bus-alert-table> </caass-school-bus-alert-table>
			</div>
		</p-accordionTab>
	</p-accordion>
</div>

<!--Table of Alerts Sent By Buses-->
<div class="AccordianDiv" style="margin-top: 15px">
	<p-accordion>
		<p-accordionTab
			header="Alerts Sent by Buses to School {{ BusAlertsExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}"
			[(selected)]="BusAlertsExpand"
		>
			<div>
				<caass-bus-alert-table (RefreshAlerts)="onRefresh()"> </caass-bus-alert-table>
			</div>
		</p-accordionTab>
	</p-accordion>
</div>

<!--Geo Fence Alerts-->
<div class="AccordianDiv" style="margin-top: 15px">
	<p-accordion>
		<p-accordionTab
			header="Alerts Created by Geo Fences {{ GeoFenceAlertsExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}"
			[(selected)]="GeoFenceAlertsExpand"
		>
			<div>
				<caass-geo-fence-alert-table (RefreshAlerts)="onRefresh()"> </caass-geo-fence-alert-table>
			</div>
		</p-accordionTab>
	</p-accordion>
</div>
